import * as secrets from '@wix/auto_sdk_secrets_secrets';

export { secrets };
